<!---
    /**
    * File and all contents are proprietary work of Executives On The Web Ltd
    * and must not be copied or redistributed without express permission.
    *
    * Creates a date picker object that can be used within a form
    *
    * @since 20200707
    * @author Matthew Allen <mallen@executivesontheweb.com>
    *
    * @copyright (c) 2020 Executives On The Web Ltd. All right Reserved.
    */
--->
<template>
    <div class="notifier">
        <a class="nav-link text-dark mr-3" href="#" id="notifier-pop">
            <i class="fa fa-wrench fa-lg pr-1 text-mustard" aria-hidden="true"></i><span class="hidden-mobile">Updates</span>
            <span v-show="newUpdates" class="badge badge-pill badge-secondary align-top">1</span>
        </a>
        <b-popover target="notifier-pop" @show="updatesViewed" triggers="focus hover click" placement="bottom" custom-class="notification-wrapper" :show.sync="popoverShow">
            <b-button @click="onClose" class="close" aria-label="Close">
                <span class="d-inline-block" aria-hidden="true">&times;</span>
            </b-button>
            <div class="inner-content"  v-html="updateLog">
            </div> 
        </b-popover>
    </div>
</template>
<script>
    export default{
        name: 'UpdateNotifier',
        mounted: async function() {
            let updates;
            try {
                updates = await this.$http.get('/api/v1/changelog')
            } catch(error) {
                this.updateLog = '<p>An error occured getting application updates. Please try reloading the page</p>';
            }

            if (updates) {
                this.updateLog = updates.data.content;
                const lastViewedUpdates = new Date(JSON.parse(localStorage.getItem('lastViewedUpdates')));
                const lastSoftwareUpdate = Date.parse(updates.data.last_update);
                if (lastViewedUpdates.typeof == "undefined" || lastSoftwareUpdate > lastViewedUpdates) {
                    this.newUpdates = true;
                }
            }
        },
        data() {
            return {
                updateLog: '',
                newUpdates: false,
                popoverShow: false
            }
        },
        methods: {
            onClose() {
                this.popoverShow = false
            },
            updatesViewed: function() {
                localStorage.setItem('lastViewedUpdates', JSON.stringify(Date.now()));
            }
        }
    }
</script>